(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('skillHeader', skillHeader);

    function skillHeader() {
        return {
            templateUrl: '/app/directives/skill-header.tpl.html',
            scope: {
                item: '=',
                formData: '='
            },
            controller: SkillHeaderController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function SkillHeaderController($state, $stateParams, logger, modalDialogService) {
        var vm = this;

        vm.currentValidity = vm.item.validity;
        vm.maxValidity = 1200;

        switch ($state.current.name) {
            case 'app-main.admin-clusteractions.edit-clusteraction':
                vm.nameEditable = true;
                vm.validityEditable = true;
                break;
            case 'app-main.admin-clusteractions.individuals.edit-skill':
            case 'app-main.admin-clusteractions.functions.add-skill':
            case 'app-main.admin-clusteractions.functions.edit-skill':
            case 'app-main.admin-skills.functions.add-skill':
            case 'app-main.admin-skills.functions.edit-skill':
                if (vm.item.validityNotEditable) {
                    vm.maxValidity = vm.item.clusterActionValidity || vm.item.validity;
                }

                vm.validityEditable = true;
                break;
        }
    }
})();